import { call, takeEvery, put, delay } from 'redux-saga/effects'

import { onGetSubscriptionState, onSetSubscriptionState } from '../actions'

export function getSubscriptionState(OneSignal) {
  return Promise.all([
    OneSignal.getNotificationPermission(),
    OneSignal.isPushNotificationsEnabled(),
    OneSignal.isOptedOut(),
  ]).then(([permission, isPushEnabled, isOptedOut]) => ({
    permission,
    isPushEnabled,
    isOptedOut,
  }))
}

export function* handleGetSubscription() {
  try {
    let OneSignal = window.OneSignal
    let waiting = 0
    while (!OneSignal) {
      OneSignal = window.OneSignal
      if (waiting > 10000) {
        throw new Error(`Exit wait timeout. Waited ${waiting} milliseconds`)
      }
      waiting += 200
      yield delay(200)
    }

    yield put(onSetSubscriptionState(yield call(getSubscriptionState, OneSignal)))
  } catch (e) {
    console.log('handleGetSubscription', e)
  }
}

export default function* handleGetSubscriptionTakeEvery() {
  yield takeEvery(onGetSubscriptionState, handleGetSubscription)
}
